import React, { useEffect,  useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { FaArrowLeft, FaClipboardList, FaExclamationCircle } from 'react-icons/fa';
import axios from '../../../api/axios';
import BottomNav from "../../../components/BottomNav"; // sesuaikan path
import HeaderWithBack from '../../../components/HeaderWithBack';
import { time } from 'console';

const Disclaimer: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { practitionerRoleId } = useParams<{ practitionerRoleId: string }>();
  const storedData = sessionStorage.getItem('userData');
  const userData = storedData ? JSON.parse(storedData) : null;
  const token = userData ? userData.token : null;
  const [isLoading, setIsLoading] = useState(false);
  const selectedTime = location.state?.selectedTime;

  // const handleContinue = () => {
  //   navigate('/connect-doctor'); // ganti dengan rute yang sesuai
  // }

  const [pertanyaan, setPertanyaan] = React.useState({
    berat: '',
    tinggi: '',
    lamaSakit: '',
    minumObat: '',
    riwayatCovid: ''
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setPertanyaan(prev => ({ ...prev, [name]: value }));
  };

  const handleContinue = async () => {
    setIsLoading(true); // mulai loading
    try {
      const response = await axios.post(
        `teleconsultation/disclaimer`,
        {
          practitioner_role_id: practitionerRoleId,
          user_id: userData?.id,
          pertanyaan: pertanyaan,
          time: selectedTime,
          consultation_date: new Date().toISOString().slice(0, 10), // yyyy-mm-dd
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = response.data;
      sessionStorage.setItem('teleconsultationData', JSON.stringify(data));
      sessionStorage.setItem('pertanyaanData', JSON.stringify(pertanyaan));

      if (selectedTime) {
        navigate('/home'); // Ganti dengan rute yang sesuai jika ada waktu yang dipilih
      } else {
        navigate(`/connect-doctor/${data.teleconsultation_id}`); // Ganti dengan rute yang sesuai\
      }
      
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false); // hentikan loading
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col">
      {/* Header */}
      <HeaderWithBack title="Disclaimer" />

      {/* Profile */}
      <div className="flex justify-center mt-4">
        <div className="bg-white p-4 rounded-xl shadow-md text-center w-11/12 max-w-md">
          <img
            src={userData?.person.avatar_url || `https://m.linksehat.com/assets/img/users/${userData?.person.gender}-avatar.png`}
            alt="Avatar"
            className="w-16 h-16 rounded-full mx-auto mb-2"
          />
          <p className="text-teal-700 font-semibold">({userData?.person.name})</p>
        </div>
      </div>

      {/* Pertanyaan */}
      <div className="flex justify-center mt-4">
        <div className="bg-white p-4 rounded-xl shadow-md w-11/12 max-w-md">
          <div className="flex items-center mb-2">
            <FaClipboardList className="text-teal-500 mr-2" />
            <h2 className="text-teal-600 font-bold text-lg">Pertanyaan</h2>
          </div>
          <p className="mb-4">Silahkan jawab Pertanyaan berikut ini:</p>

          {/* Input Berat */}
          <div className="mb-4">
            <label className="font-medium">
              Berapa berat badan Anda? <span className="text-red-500">*</span>
            </label>
            <input
              type="number"
              placeholder="Masukkan berat badan (kg)"
              className="w-full mt-1 p-2 border rounded"
              name="berat"
              onChange={handleInputChange}
            />
          </div>

          {/* Input Tinggi */}
          <div className="mb-4">
            <label className="font-medium">
              Berapa tinggi badan Anda? <span className="text-red-500">*</span>
            </label>
            <input
              type="number"
              placeholder="Masukkan tinggi badan (cm)"
              className="w-full mt-1 p-2 border rounded"
              name='tinggi'
              onChange={handleInputChange}
            />
          </div>

          {/* Radio: Sakit lebih 3 hari */}
          <div className="mb-4">
            <label className="font-medium">Apakah sakit sudah lebih dari 3 hari?</label>
            <div className="flex gap-4 mt-1">
              <label><input type="radio" name="lamaSakit" onChange={handleInputChange} value={1}/> Ya</label>
              <label><input type="radio" name="lamaSakit" onChange={handleInputChange} value={0}/> Tidak</label>
            </div>
          </div>

          {/* Radio: Sudah minum obat */}
          <div className="mb-4">
            <label className="font-medium">Apakah sudah minum obat?</label>
            <div className="flex gap-4 mt-1">
              <label><input type="radio" name="minumObat" onChange={handleInputChange} value={1}/> Ya</label>
              <label><input type="radio" name="minumObat" onChange={handleInputChange} value={0}/> Tidak</label>
            </div>
          </div>

          {/* Radio: Riwayat Covid */}
          <div className="mb-4">
            <label className="font-medium">Apakah anda memiliki riwayat covid?</label>
            <div className="flex gap-4 mt-1">
              <label><input type="radio" name="riwayatCovid" onChange={handleInputChange} value={1}/> Ya</label>
              <label><input type="radio" name="riwayatCovid" onChange={handleInputChange} value={0}/> Tidak</label>
            </div>
          </div>
        </div>
      </div>

      {/* Disclaimer Box */}
      <div className="flex justify-center mt-4 mb-4 px-4">
        <div className="w-full md:w-7/12 bg-white text-gray-800 rounded-lg shadow-lg border border-gray-200">
          <div className="p-3">
            <h3 className="text-2xl font-semibold flex items-center gap-2">
              <FaExclamationCircle className="text-teal-500" />
              Disclaimer
            </h3>
          </div>
          <hr className="w-full border-gray-200" />
          <div className="p-3 text-sm">
            <p>
              Fasilitas ini belum menjamin kepastian diagnosa kondisi yang dialami.
              Perbincangan dalam aplikasi tidak bisa menggantikan interaksi fisik dengan dokter.
              Untuk kondisi darurat, segera temui dokter langsung.
            </p>
          </div>
        </div>
      </div>
      {/* Tombol Cancel dan Continue */}
      <div className="flex w-full justify-between mt-4 mb-28 px-4">
        <div>
          <button
            onClick={() => navigate('/home')}
            className="px-6 py-2 text-gray-800 uppercase bg-white rounded-full shadow-lg"
          >
            Cancel
          </button>
        </div>
        <div>
          <button
            onClick={handleContinue}
            disabled={isLoading}
            type="submit"
            className="px-6 py-2 text-white uppercase rounded-full shadow-lg bg-teal-500"
            id="btnRequest"
            name="request"
            value="1"
          >
            {isLoading ? (
                <div className="flex items-center justify-center space-x-2">
                  <svg
                    className="animate-spin h-5 w-5 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8v8H4z"
                    ></path>
                  </svg>
                  <span>Loading...</span>
                </div>
              ) : (
                'Continue'
              )}  
          </button>
        </div>
      </div>

      {/* Bottom Navigation */}
      <BottomNav />
    </div>
  );
};

export default Disclaimer;
